import { Box } from "@mui/material";
import HealthScoreQuestionnaire from ".";
import { QuestionnaireAnswer } from "./types";
import {
  MOCK_MULTI_SELECT_QUESTIONS,
  MOCK_QUESTIONS,
  MOCK_MENTAL_WELLBEING_QUESTIONS,
} from "./index.mocks";

export function LifeStyleQuestionnaireExample() {
  const handleSubmit = async (answers: QuestionnaireAnswer[]) => {
    console.log("Submitting answers:", answers);
  };

  const handleClose = () => {
    console.log("Closing questionnaire");
  };

  return (
    <Box sx={{ height: "100vh" }}>
      <HealthScoreQuestionnaire
        questions={MOCK_QUESTIONS}
        translationPrefix="Lifestyle.questionnaire"
        onSubmit={handleSubmit}
        onClose={handleClose}
        title="Example Questionnaire"
      />
    </Box>
  );
}

export function HealthHistoryQuestionnaireExample() {
  const handleSubmit = async (answers: QuestionnaireAnswer[]) => {
    console.log("Submitting answers:", answers);
  };

  const handleClose = () => {
    console.log("Closing questionnaire");
  };

  return (
    <Box sx={{ height: "100vh" }}>
      <HealthScoreQuestionnaire
        questions={MOCK_MULTI_SELECT_QUESTIONS}
        translationPrefix="HealthHistory.questionnaire"
        onSubmit={handleSubmit}
        onClose={handleClose}
        title="Health History Questionnaire"
      />
    </Box>
  );
}

export function MentalWellbeingQuestionnaireExample() {
  const handleSubmit = async (answers: QuestionnaireAnswer[]) => {
    console.log("Submitting answers:", answers);
  };

  const handleClose = () => {
    console.log("Closing questionnaire");
  };

  return (
    <Box sx={{ height: "100vh" }}>
      <HealthScoreQuestionnaire
        questions={MOCK_MENTAL_WELLBEING_QUESTIONS}
        translationPrefix="MentalWellbeing.questionnaire"
        onSubmit={handleSubmit}
        onClose={handleClose}
        title="Mental Wellbeing Questionnaire"
      />
    </Box>
  );
}
